import { useState, useEffect, useRef, Fragment } from "react";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import _ from "lodash";
import axios from "axios";
import { CRYPTOURL, CRYPTO_MERCHANT, DEOSITBONUSURL,} from "../../DataStore/ApiConstant";
import BonusOffer from "../TransactionCommon/BonusOffer";
import { useAtom } from "jotai";
import { bonusStore } from "../../DataStore/atom";
import { getFormData, calculateBonus, calculateTurnover } from "../../utils";
import { useDepositBonus } from "../../services/cashier";
import { useCurrencyRates } from "../../services/cashier";
import { useInrToUsd } from "../../services/config";
import {NumericFormat} from "react-number-format";
import QRupiComponent from "../Modal/GeneralModal/QRupiComponent";


const currencyRules = [
  { currency: "LKR", min: 1000, max: 150000 }
];

const getValidatorSchema = () => {
  const { min, max } = currencyRules.find((rule) => rule.currency === "LKR");
  return yup.object().shape({
    amount: yup
      .number()
      // .required("Please provide amount.")
      .min(min, `Must be greater than or equal to ${min}`)
      .max(max, `Must be less than or equal to ${max}`)
      .typeError("Amount must be a number"),
  });
};


const LocalBankDeposit = ({ successMessage, cashierReturnStatus, cashierReturnDepositPill }) => {
  const [BonusStore, setBonusStore] = useAtom(bonusStore);
  const [depositBonus, setDepositBonus] = useState(true);
  const [reBonus, setReBonus] = useState(0);
  const [reTurn, setReTurn] = useState(0);
  const [usd, setUsd] = useState(0);
  const [load, setLoad] = useState(false);

  const [lkrAmount, setLkrAmount] = useState(0);
  const [inrAmount, setInrAmount] = useState(0);

  const [selectedOption, setSelectedOption] = useState(1);

  const [showSuccessMessageKey, setShowSuccessMessageKey] = useState(null);
  const [amount, setAmount] = useState(0);
  const [errmsg, setErrmsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loader, setLoader] = useState(false);
  const [paymentErr, setPaymentErr] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const statusMessageRef = useRef(null);

  const schema = getValidatorSchema();
  const { handleSubmit, formState: { errors }, register, reset } = useForm({ resolver: yupResolver(schema) });
  
  // const bonus = useWithdrawBonus();
  const currency = useCurrencyRates();
  const bonus = useDepositBonus();
  const InrToUsd = useInrToUsd();
  // console.log(currency?.data?.data[0]?.rate);
  // console.log(currency?.data?.data[36]?.rate);
  
  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      // style: 'currency',
      currency: 'USD',
    }).format(amount);
  };

  const postRedirect = (url, data = {}, target = "_self") => {
    if (!url) return;

    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;
    form.target = target;

    Object.entries(data || {}).forEach(([key, val]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = val == null ? "" : String(val);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    form.remove();
  };

  const submitHandler = async () => {
    const numericAmount = Number(amount);

    if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
      setPaymentErr("error-invalid-amount");
      const timer = setTimeout(() => setPaymentErr(null), 5000);
      return () => clearTimeout(timer);
    }

    // Used by the /cashier/success callback to reopen the correct inner tab.
    localStorage.setItem("cashierReturnDepositPill", "bankdeposit");

    // If calculateBonuses already flagged invalid min/max, block submit
    if (paymentErr) return;

    setLoad(true);
    setErrmsg("");
    setSuccessMsg("");

    try {
      const bonusAmt = depositBonus == null ? 0 : 1;
      const payload = { bonus: bonusAmt, fiatAmount: String(numericAmount), provider: "bank" };

      const resp = await axios.post(CRYPTOURL, payload);
      const data = resp?.data;

      if (!data?.success) {
        setErrmsg(data?.error || "error-unknown-error-has-occurred");
        return;
      }

      if (data?.type === "qr") {
        setQrCodeUrl(data?.value || null);
        setIsModalOpen(true);
        return;
      }

      if (data?.type === "url") {
        // requirement: send POST req to `value` with `postData`
        if (data?.postData && typeof data.postData === "object") {
          postRedirect(data.value, data.postData, "_self");
          return;
        }
        // fallback
        window.location.href = data?.value;
        return;
      }

      // fallback for any other success type/value
      if (data?.value) window.location.href = data.value;
      else setErrmsg("error-unexpected-payment-response");
    } catch (err) {
      setErrmsg(err?.response?.data?.error || err?.message || "error-payment-request-failed");
    } finally {
      setLoad(false);
    }
  };

  const handleFocus = (event) => {
    event.target.select();
  };
  
  const calculateBonuses = (reAmount) => {
    setAmount(reAmount);
    const { min, max } = currencyRules.find((rule) => rule.currency === "LKR");
      if (reAmount !== "" && (reAmount < min || reAmount > max)) {
        setPaymentErr(`LKR amount must be between min and max limit: ${min} - ${new Intl.NumberFormat('en-LK', { style: 'currency', currency: 'LKR', maximumFractionDigits: 0 }).format(max)}`);
        setLoad(true)
      } else {
        setPaymentErr(false);
        setLoad(false)
      }

    
    // if (bonus.data) {
    //   let bonusRet = calculateBonus(
    //     reAmount,
    //     bonus?.data?.maxbonus || 0,
    //     bonus?.data?.bonusprecent || 0
    //   );
    //   setReBonus(bonusRet);
    //   let turnRet = calculateTurnover(
    //     reAmount,
    //     bonus?.data?.maxbonus || 0,
    //     bonus?.data?.turnover || 0,
    //     bonus?.data?.bonusprecent || 0
    //   );
    //   setReTurn(turnRet)
      
    // }
    // // if(!InrToUsd.isLoading && InrToUsd?.data){
      
    // // let lkrToUsdAmount = parseFloat(reAmount) * parseFloat(InrToUsd?.data?.[0]?.value || 0.012)
    // // let lkrToUsdAmount = (parseFloat( !currency.isLoading && currency?.data?.data?.[0]?.rate) / parseFloat(!currency.isLoading && currency?.data?.data?.[36]?.rate) * parseFloat(reAmount))
    // let usdCurrency = !currency.isLoading && currency?.data?.data.find(item => item.cur === "USD")
    // let inrCurrency = !currency.isLoading && currency?.data?.data.find(item => item.cur === "INR")
    
    // let calculatedInr = (parseFloat(usdCurrency.rate) / (parseFloat( inrCurrency.rate)) * parseFloat(reAmount))
    // let calculatedLkr = (parseFloat(reAmount) * parseFloat(usdCurrency.rate))
    // setInrAmount(calculatedInr.toFixed(0))
    // setLkrAmount(calculatedLkr.toFixed(0))

    //   const { min, max } = currencyRules.find((rule) => rule.currency === "USD");
    //   if (reAmount !== "" && (reAmount < min || reAmount > max)) {
    //     setPaymentErr(`USD amount must be between min and max limit: ${min} - ${new Intl.NumberFormat('en-LK', { style: 'currency', currency: 'LKR', maximumFractionDigits: 0 }).format(max)}`);
    //     setLoad(true)
    //   } else {
    //     setPaymentErr(false);
    //     setLoad(false)
    //   }
      // lkrToUsdAmount = parseFloat(lkrToUsdAmount.toFixed(3));
      // setUsd(lkrToUsdAmount || 0)
    // }
  };
  const bonusOfferSwitch = async (status) => {
    setSelectedOption((prevOption) => (prevOption === status ? "" : status));

    setBonusStore(status);
    if (status) {
      axios
        .get(DEOSITBONUSURL)
        .then((resp) => {
          setDepositBonus(resp);
        })
        .catch((err) => {});
    } else {
      setDepositBonus(null);
    }
  };

  useEffect(() => {
    reset();
  }, [reset]);

  useEffect(() => {
    if (cashierReturnDepositPill !== "bankdeposit") return;
    if (
      cashierReturnStatus !== "success" &&
      cashierReturnStatus !== "cancel" &&
      cashierReturnStatus !== "fail"
    )
      return;

    setShowSuccessMessageKey(
      cashierReturnStatus === "success"
        ? "localbankdeposit-transaction-success"
        : "localbankdeposit-transaction-failed"
    );

    const timer = setTimeout(() => {
      setShowSuccessMessageKey(null);
    }, 10000);

    return () => clearTimeout(timer);
  }, [cashierReturnStatus, cashierReturnDepositPill]);

  useEffect(() => {
    if (!showSuccessMessageKey) return;

    // Ensure the user sees the gateway return status banner.
    // Scroll to the banner if possible; otherwise scroll to the tab pane.
    const bannerEl = statusMessageRef.current;
    const fallbackPane = document.getElementById("v-pills-bankdeposit");
    (bannerEl || fallbackPane)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [showSuccessMessageKey]);
  return (
    <Fragment>
    <div
      className="tab-pane fade "
      id="v-pills-bankdeposit"
      role="tabpanel"
      aria-labelledby="v-pills-bankdeposit-tab"
    >
      <div className="row">
        <form onSubmit={handleSubmit(submitHandler)}>
            <div className="">
                  <div className="row d-flex justify-content-center">

            <div className="row d-flex justify-content-center my-5">

            <div className="col-md-4 mb-3">
              <div className="row">
                <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  <TranslatesContent contentKey="deposit-amount-in-lkr" />
                </label>
                <div className="input-group">
                  <span
                    className="input-group-text"
                    style={{
                      border: "1px solid #2f2f2f",
                      fontWeight: 600,
                      backgroundColor: "#c7c7c7"
                    }}
                  >
                    LKR
                  </span>
                  <NumericFormat
                      style={{textAlign: "right", height: "2.5rem" }}
                      value={amount}
                      {...register("amount")}
                      thousandSeparator={true}
                      // decimalScale={2}
                      fixedDecimalScale={true}
                      className={`form-control ${_.isEmpty(errors) ? '' : errors?.amount ? 'is-invalid' : 'is-valid'}`}
                      onValueChange={(values) => {
                        const { value } = values;
                        calculateBonuses(value);                      
                      }}
                      onFocus={handleFocus}
                      placeholder="0"
                      // customInput="input"
                    />
                  <div className="col-12">
                    <div className="form-text text-center">
                      <TranslatesContent contentKey="min-max-limit-lkr-1000-150000" />
                    </div>
                  </div>
                  {/* <div class="form-text">Min/Max Limit: INR 500 / INR 5000</div> */}
                </div>
                {/* {amount != 0 ? (
                  <div className="col-md-12 d-flex">
                    <div className="preview-box flex-fill">
                      In INR: <span id="preview1">{new Intl.NumberFormat('en-IN', { currency: 'INR' }).format(inrAmount)}</span>
                    </div>
                    <div className="preview-box flex-fill">
                      In LKR: <span id="preview2">{new Intl.NumberFormat('en-LK', { currency: 'LKR' }).format(lkrAmount)}</span>
                    </div>
                  </div>
                ) : ""} */}
              </div>
            </div>

              
              {/* <div className="col-md-4 mb-3"> */}
                {/* <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  Enter Amount in INR
                </label> */}
                {/* <div className="input-group"> */}
                  {/* <span
                    className="input-group-text"
                    style={{
                      border: "1px solid #2f2f2f",
                      fontWeight: 600,
                      backgroundColor: "#c7c7c7"
                    }}
                  >
                    INR
                  </span> */}
                  {/* <input
                    type="text"
                    className="form-control"
                    aria-label="Dollar amount (with dot and two decimal places)"
                  /> */}
                  {/* <NumericFormat
                    style={{ width: "8rem", textAlign: "right", height: "2.5rem" }}
                    value={amount}
                    {...register("amount")}
                    thousandSeparator={true}
                    // decimalScale={2}
                    fixedDecimalScale={true}
                    className={`form-control ${_.isEmpty(errors) ? '' : errors?.amount ? 'is-invalid' : 'is-valid'}`}
                    onValueChange={(values) => {
                      const { value } = values;
                      calculateBonuses(value);                      
                    }}
                    onFocus={handleFocus}
                    // customInput="input"
                  /> */}
                  {/* <div className="col-12">
                    <div className="form-text text-center">
                      Min/Max Limit: INR 500 / INR 5000
                    </div>
                  </div> */}
                  {/* <div class="form-text">Min/Max Limit: INR 500 / INR 5000</div> */}
                {/* </div>
              </div> */}
              {/* <div className="col-md-4 mb-3">
                <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  Chargeble USD Amount{" "}
                </label>
                <div className="input-group">
                  <input
                    style={{textAlign:"right"}}
                    value={formatAmount(usd)}
                    className="form-control"
                    type="text"
                    defaultValue="Readonly input here..."
                    aria-label="readonly input example"
                    readOnly=""
                  />
                </div>
              </div> */}
                  {errors?.amount?.message && (
                    <div className="invalid-feedback">
                      {errors.amount.message}
                    </div>
                                      )}
              <div className="row d-flex justify-content-center">

              <div className="col-md-3 mb-3">
                <div className="row">
                  <div className="col-12" style={{ textAlign: "center" }}>
                    <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                      <TranslatesContent contentKey="deposit-bonus-activation-in-local-bank" />
                    </label>
                  </div>
                  <div className="d-flex justify-content-center">
                    <div className="px-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          style={{padding:"0"}}
                          type="radio"
                          defaultValue=""
                          id="flexCheckDefault"
                          checked={selectedOption === 1}
                          onChange={() => bonusOfferSwitch(1)}
                        />
                        <label
                          className="form-check-label mt-1 ms-2"
                          htmlFor="flexCheckDefault"
                        >
                          <TranslatesContent contentKey="yes-in-deposit-local-bank" />
                        </label>
                      </div>
                    </div>
                    <div className="px-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          style={{padding:"0"}}
                          type="radio"
                          defaultValue=""
                          id="flexCheckDefault"
                          checked={selectedOption === 0}
                          onChange={() => bonusOfferSwitch(0)}
                        />
                        <label
                          className="form-check-label mt-1 ms-2"
                          htmlFor="flexCheckChecked"
                        >
                          <TranslatesContent contentKey="no-in-deposit-local-bank" />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


                {/* <label htmlFor="exampleFormControlInput1" className="cashierNewTitel">
                  Bonus
                </label>
                <div className="fform-check form-switch form-switch-lg">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    defaultChecked=""
                    data-val="1"
                    checked={BonusStore}
                    onChange={(e) => {
                      bonusOfferSwitch(e.target.checked);
                    }}
                  />
                
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckChecked"
                    style={{ marginLeft: 15, marginTop: 10 }}
                  >
                    Add Bonus Offer
                  </label>
                </div> */}
              </div>
              <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mb-3">
                      {successMsg && (
                        <div
                          style={{ marginTop: "30px" }}
                          className="alert alert-success"
                        >
                          {successMsg}
                        </div>
                      )}
                      {errmsg && (
                        <div
                          style={{ marginTop: "30px" }}
                          className="alert alert-danger"
                        >
                          {typeof errmsg === "string" && errmsg.startsWith("error-") ? (
                            <TranslatesContent contentKey={errmsg} />
                          ) : (
                            errmsg
                          )}
                        </div>
                      )}
                      {paymentErr && (
                        <div
                          style={{ marginTop: "30px" }}
                          className="alert alert-danger"
                          role="alert"
                        >
                          {typeof paymentErr === "string" && paymentErr.startsWith("error-") ? (
                            <TranslatesContent contentKey={paymentErr} />
                          ) : (
                            paymentErr
                          )}
                        </div>
                      )}
                      {/* <div className="col-6 col-lg-4 col-md-4 col-sm-4">
                        <button
                          disabled={loader}
                          type="submit"
                          className="newcashierButton"
                        >
                          {loader ? (
                            "Processing..."
                          ) : (
                            <TranslatesContent contentKey="submit" />
                          )}
                        </button>
                      </div> */}
              <div>
                {showSuccessMessageKey && (
                  <div
                    ref={statusMessageRef}
                    className={
                      showSuccessMessageKey === "localbankdeposit-transaction-failed"
                        ? "success-message-error"
                        : "success-message"
                    }
                  >
                    <TranslatesContent contentKey={showSuccessMessageKey} />
                  </div>
                )}
                {/* The rest of your component code */}
              </div>
                    </div>
              </div>
            </div>
              <div class="row d-flex justify-content-center">
                  <div class="col-md-4 mb-3">
                      <button
                          type="submit"
                          className="btn btn-primary btn-lg w-100"
                          disabled={load}
                        >
                          <TranslatesContent contentKey="confirm-in-local" />
                        </button>
                    {/* <button type="submit"
                          class="btn btn-primary btn-lg w-100">CONFIRM
                          </button> */}
                  </div>
              </div>
                  </div>
                </div>
        </form>
              </div>
            </div>
          
    <div>
      <QRupiComponent
        isOpen={isModalOpen}
        onClose={closeModal}
        qrCodeValue={qrCodeUrl}
      />
    </div>
    </Fragment>
    
  );
};

export default LocalBankDeposit;
